import {Injectable} from '@angular/core';

declare var Webtrends: any;

@Injectable()
export class WebtrendsService {

  track(evt) {
    // Webtrends.trackNgEvent(evt);
  }

  multiTrack(window, url, title, upid) {
    // window.Webtrends.multiTrack({
    //   argsa: ['DCS.dcsuri', url, 'WT.ti', title,
    //     'DCSext.WT_UPID', upid, 'WT.cg_n', 'Account', 'WT.dl', '0']
    // });
  }
}
